import { render, staticRenderFns } from "./blogNew.vue?vue&type=template&id=0dcf995c"
import script from "./blogNew.vue?vue&type=script&lang=js"
export * from "./blogNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports